import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { ScrollArea } from "@/components/ui/scroll-area";
import { LEGAL_DOCS, LegalDoc } from "@/lib/legalContent";

interface LegalDialogProps {
  docKey: LegalDoc["key"] | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const LegalDialog = ({ docKey, open, onOpenChange }: LegalDialogProps) => {
  const doc = docKey ? LEGAL_DOCS[docKey] : null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        dir="rtl"
        className="max-w-3xl max-h-[85vh] p-0 gap-0 bg-background border-border"
      >
        <DialogHeader className="px-6 pt-6 pb-4 border-b border-border text-right">
          <DialogTitle className="text-2xl font-bold text-foreground">
            {doc?.title}
          </DialogTitle>
          <DialogDescription className="text-sm text-muted-foreground">
            עודכן לאחרונה: {doc?.updated}
          </DialogDescription>
        </DialogHeader>
        <ScrollArea className="max-h-[65vh] px-6 py-5 text-right">
          {doc?.content}
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
};

export const useLegalDialog = () => {
  const [openKey, setOpenKey] = useState<LegalDoc["key"] | null>(null);

  const trigger = (key: LegalDoc["key"]) => setOpenKey(key);
  const dialog = (
    <LegalDialog
      docKey={openKey}
      open={openKey !== null}
      onOpenChange={(o) => !o && setOpenKey(null)}
    />
  );

  return { trigger, dialog };
};

export default LegalDialog;
